// extracted by mini-css-extract-plugin
export default {"totalLayout":"DailyActivities_totalLayout__NlJ7D","SubHeading":"DailyActivities_SubHeading__KzqrA","formLayout":"DailyActivities_formLayout__O+nfy"};